export enum ItalianBillingCountry {
  Italy = "IT",
  Livigno = "IT-LIVIGNO",
}

export type BillingCountry = {
  code: string;
  name: string;
};

const ITALY: BillingCountry = {
  code: ItalianBillingCountry.Italy,
  name: "Italia",
};

const OTHER_COUNTRIES_BY_ITALIAN_NAME: BillingCountry[] = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antartide" },
  { code: "AG", name: "Antigua e Barbuda" },
  { code: "SA", name: "Arabia Saudita" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaigian" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrein" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BE", name: "Belgio" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BY", name: "Bielorussia" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia ed Erzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BR", name: "Brasile" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "KH", name: "Cambogia" },
  { code: "CM", name: "Camerun" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Capo Verde" },
  { code: "BQ", name: "Caraibi Olandesi" },
  { code: "CZ", name: "Cechia" },
  { code: "TD", name: "Ciad" },
  { code: "CL", name: "Cile" },
  { code: "CN", name: "Cina" },
  { code: "CY", name: "Cipro" },
  { code: "VA", name: "Città del Vaticano" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comore" },
  { code: "CD", name: "Congo - Kinshasa" },
  { code: "CG", name: "Congo-Brazzaville" },
  { code: "KP", name: "Corea del Nord" },
  { code: "KR", name: "Corea del Sud" },
  { code: "CI", name: "Costa d’Avorio" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croazia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Curaçao" },
  { code: "DK", name: "Danimarca" },
  { code: "DM", name: "Dominica" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egitto" },
  { code: "SV", name: "El Salvador" },
  { code: "AE", name: "Emirati Arabi Uniti" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Etiopia" },
  { code: "FJ", name: "Figi" },
  { code: "PH", name: "Filippine" },
  { code: "FI", name: "Finlandia" },
  { code: "FR", name: "Francia" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "GS", name: "Georgia del Sud e Sandwich Australi" },
  { code: "DE", name: "Germania" },
  { code: "GH", name: "Ghana" },
  { code: "JM", name: "Giamaica" },
  { code: "JP", name: "Giappone" },
  { code: "GI", name: "Gibilterra" },
  { code: "DJ", name: "Gibuti" },
  { code: "JO", name: "Giordania" },
  { code: "GR", name: "Grecia" },
  { code: "GD", name: "Grenada" },
  { code: "GL", name: "Groenlandia" },
  { code: "GP", name: "Guadalupa" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GQ", name: "Guinea Equatoriale" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "GF", name: "Guyana Francese" },
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Irlanda" },
  { code: "IS", name: "Islanda" },
  { code: "BV", name: "Isola Bouvet" },
  { code: "CX", name: "Isola Christmas" },
  { code: "IM", name: "Isola di Man" },
  { code: "NF", name: "Isola Norfolk" },
  { code: "AX", name: "Isole Åland" },
  { code: "KY", name: "Isole Cayman" },
  { code: "CC", name: "Isole Cocos (Keeling)" },
  { code: "CK", name: "Isole Cook" },
  { code: "FO", name: "Isole Fær Øer" },
  { code: "FK", name: "Isole Falkland" },
  { code: "HM", name: "Isole Heard e McDonald" },
  { code: "MP", name: "Isole Marianne Settentrionali" },
  { code: "MH", name: "Isole Marshall" },
  { code: "UM", name: "Isole Minori Esterne degli Stati Uniti" },
  { code: "PN", name: "Isole Pitcairn" },
  { code: "SB", name: "Isole Salomone" },
  { code: "TC", name: "Isole Turks e Caicos" },
  { code: "VI", name: "Isole Vergini Americane" },
  { code: "VG", name: "Isole Vergini Britanniche" },
  { code: "IL", name: "Israele" },
  { code: "JE", name: "Jersey" },
  { code: "KZ", name: "Kazakistan" },
  { code: "KE", name: "Kenya" },
  { code: "KG", name: "Kirghizistan" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "LA", name: "Laos" },
  { code: "LS", name: "Lesotho" },
  { code: "LV", name: "Lettonia" },
  { code: "LB", name: "Libano" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libia" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lituania" },
  { code: ItalianBillingCountry.Livigno, name: "Livigno" },
  { code: "LU", name: "Lussemburgo" },
  { code: "MK", name: "Macedonia del Nord" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldive" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MA", name: "Marocco" },
  { code: "MQ", name: "Martinica" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Messico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldavia" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MZ", name: "Mozambico" },
  { code: "MM", name: "Myanmar (Birmania)" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NO", name: "Norvegia" },
  { code: "NC", name: "Nuova Caledonia" },
  { code: "NZ", name: "Nuova Zelanda" },
  { code: "OM", name: "Oman" },
  { code: "NL", name: "Paesi Bassi" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua Nuova Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Perù" },
  { code: "PF", name: "Polinesia Francese" },
  { code: "PL", name: "Polonia" },
  { code: "PT", name: "Portogallo" },
  { code: "PR", name: "Portorico" },
  { code: "QA", name: "Qatar" },
  { code: "HK", name: "RAS di Hong Kong" },
  { code: "MO", name: "RAS di Macao" },
  { code: "GB", name: "Regno Unito" },
  { code: "CF", name: "Repubblica Centrafricana" },
  { code: "DO", name: "Repubblica Dominicana" },
  { code: "RE", name: "Riunione" },
  { code: "RO", name: "Romania" },
  { code: "RW", name: "Ruanda" },
  { code: "RU", name: "Russia" },
  { code: "EH", name: "Sahara Occidentale" },
  { code: "KN", name: "Saint Kitts e Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin" },
  { code: "VC", name: "Saint Vincent e Grenadine" },
  { code: "BL", name: "Saint-Barthélemy" },
  { code: "PM", name: "Saint-Pierre e Miquelon" },
  { code: "WS", name: "Samoa" },
  { code: "AS", name: "Samoa Americane" },
  { code: "SM", name: "San Marino" },
  { code: "SH", name: "Sant’Elena" },
  { code: "ST", name: "São Tomé e Príncipe" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SY", name: "Siria" },
  { code: "SK", name: "Slovacchia" },
  { code: "SI", name: "Slovenia" },
  { code: "SO", name: "Somalia" },
  { code: "ES", name: "Spagna" },
  { code: "LK", name: "Sri Lanka" },
  { code: "US", name: "Stati Uniti" },
  { code: "SS", name: "Sud Sudan" },
  { code: "ZA", name: "Sudafrica" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard e Jan Mayen" },
  { code: "SE", name: "Svezia" },
  { code: "CH", name: "Svizzera" },
  { code: "TJ", name: "Tagikistan" },
  { code: "TW", name: "Taiwan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TF", name: "Terre Australi Francesi" },
  { code: "PS", name: "Territori Palestinesi" },
  { code: "IO", name: "Territorio Britannico dell’Oceano Indiano" },
  { code: "TH", name: "Thailandia" },
  { code: "TL", name: "Timor Est" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad e Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turchia" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TV", name: "Tuvalu" },
  { code: "UA", name: "Ucraina" },
  { code: "UG", name: "Uganda" },
  { code: "HU", name: "Ungheria" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "WF", name: "Wallis e Futuna" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

export const billingCountries: BillingCountry[] = [
  ITALY,
  ...OTHER_COUNTRIES_BY_ITALIAN_NAME,
];

const ITALIAN_BILLING_COUNTRIES: string[] = Object.values(
  ItalianBillingCountry,
);

export function isForeignBillingCountry(country?: string): boolean {
  return !!country && !ITALIAN_BILLING_COUNTRIES.includes(country);
}

export function isOutsideItalianVatTerritory(country?: string): boolean {
  return (
    isForeignBillingCountry(country) ||
    country === ItalianBillingCountry.Livigno
  );
}

export function billingCountryNameOf(country?: string): string {
  const code = country || ItalianBillingCountry.Italy;
  return (
    billingCountries.find((billingCountry) => billingCountry.code === code)
      ?.name ?? code
  );
}
